// extracted by mini-css-extract-plugin
export default {"topUsersSection":"topUsers_topUsersSection__8+96G","users":"topUsers_users__-16p9"};